var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2761 0.938534C9.78168 -0.311635 11.5517 -0.311638 12.0573 0.938532L13.5631 4.66189C13.7779 5.19321 14.2768 5.55566 14.8485 5.59583L18.8549 5.87732C20.2002 5.97184 20.7471 7.65522 19.7144 8.52238L16.6386 11.105C16.1996 11.4736 16.0091 12.06 16.1476 12.6162L17.1179 16.5135C17.4437 17.8221 16.0117 18.8625 14.8679 18.1482L11.4611 16.0211C10.975 15.7175 10.3584 15.7175 9.87223 16.0211L6.4655 18.1483C5.32164 18.8625 3.88968 17.8221 4.21548 16.5135L5.18582 12.6162C5.32428 12.06 5.13374 11.4736 4.69482 11.105L1.619 8.52238C0.586254 7.65522 1.13322 5.97184 2.47843 5.87732L6.48487 5.59583C7.05659 5.55566 7.55545 5.19321 7.77032 4.66189L9.2761 0.938534Z",
    fill: "#f1bd11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.c30f126926dcf7ce75714ca3c8be2ad7.svg";
export { ForwardRef as ReactComponent };